import { render, staticRenderFns } from "./ServicePropertiesView.vue?vue&type=template&id=243312d6&scoped=true&"
import script from "./ServicePropertiesView.vue?vue&type=script&lang=js&"
export * from "./ServicePropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243312d6",
  null
  
)

export default component.exports